var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.loading)?_c('loader'):_c('div',{staticClass:"main row"},_vm._l((_vm.products),function(product){return _c('div',{key:product.id,staticClass:"item col-xl-3 col-lg-4 col-md-6 col-12 px-2 py-3"},[_c('product-card',{attrs:{"product":product,"search":'search'}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }